import "./work-crypto.css";
import OurWorksSection from "../../../components/our-works-section/OurWorksSection";

function WorkCrypto() {
  const id = 9;

  return (
    <div className="work crypto">
      {/* Work Header */}
      <div className="work-header">
        <div className="work-branding">
          <div className="work-branding-title">
            <div className="work-branding-title-col-1">
              {window.innerWidth <= 768 ?
                <div className="work-branding-title-col-1-mobile">
                  <h3>Designed By</h3>
                  <h2>IRAKLI TALAVADZE®</h2>
                </div>
                :
                <h2
                  className="animate__animated animate__fadeIn animate__slow"
                  style={{ color: "#44F3E3" }}
                >
                  <span>CRYPTO CURRENCY - </span> Web Concepts
                </h2>
              }
              {window.innerWidth <= 768 ?
                <h2
                  className="animate__animated animate__fadeIn animate__slow"
                  style={{ color: "#44F3E3" }}
                >
                  <span>CRYPTO CURRENCY - </span> Web Concepts
                </h2>
                :
                <button
                  onClick={() => window.open("", "_blank")}
                >
                  Discover
                  &nbsp;
                  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} viewBox="0 0 12 12" fill="none">
                    <path d="M5 3V4H2.5V9.5H8V7H9V10C9 10.1326 8.94732 10.2598 8.85355 10.3536C8.75979 10.4473 8.63261 10.5 8.5 10.5H2C1.86739 10.5 1.74021 10.4473 1.64645 10.3536C1.55268 10.2598 1.5 10.1326 1.5 10V3.5C1.5 3.36739 1.55268 3.24021 1.64645 3.14645C1.74021 3.05268 1.86739 3 2 3H5ZM10.5 1.5V5.5H9.5V3.2065L5.6035 7.1035L4.8965 6.3965L8.7925 2.5H6.5V1.5H10.5Z" fill="#050320" />
                  </svg>
                </button>
              }
            </div>
            <div
              className={`work-branding-title-col-2  ${window.innerWidth <= 768 ? "d-none" : ""
                }`}
            >
              <h3>Designed By</h3>
              <h2>IRAKLI TALAVADZE®</h2>
            </div>
          </div>
          <h1
            className={`animate__animated animate__fadeIn animate__slow ${window.innerWidth <= 768 ? "d-none" : ""
              }`}
          >
            The 2025 report shows that crypto activity is hitting all-time highs! Blockchain has really grown up.
          </h1>
        </div>

        <img
          src="/assets/images/work-pages/crypto/crypto-1.webp"
          alt="Work Image"
        />

        <h1 className={`${window.innerWidth > 768 ? "d-none" : ""}`}>
          The 2025 report shows that crypto activity is hitting all-time highs! Blockchain has really grown up.
        </h1>

        <button
          className={`${window.innerWidth > 768 ? "d-none" : ""}`}
          onClick={() => window.open("", "_blank")}
        >
          Discover
          &nbsp;
          <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} viewBox="0 0 12 12" fill="none">
            <path d="M5 3V4H2.5V9.5H8V7H9V10C9 10.1326 8.94732 10.2598 8.85355 10.3536C8.75979 10.4473 8.63261 10.5 8.5 10.5H2C1.86739 10.5 1.74021 10.4473 1.64645 10.3536C1.55268 10.2598 1.5 10.1326 1.5 10V3.5C1.5 3.36739 1.55268 3.24021 1.64645 3.14645C1.74021 3.05268 1.86739 3 2 3H5ZM10.5 1.5V5.5H9.5V3.2065L5.6035 7.1035L4.8965 6.3965L8.7925 2.5H6.5V1.5H10.5Z" fill="#050320" />
          </svg>
        </button>
      </div>

      {/* Work Desc Section */}
      <div className="work-desc-section">
        <div className="work-desc">
          <p>
            WHAT is cryptocurrency? A cryptocurrency is a digital currency, which is an alternative form of payment created using encryption algorithms.
          </p>
          <p className={`${window.innerWidth <= 768 ? "d-none" : ""}`} >
            Cryptocurrencies are digital tokens. They are a type of digital currency that allows people to make payments directly to each other through an online system. Cryptocurrencies have no legislated or intrinsic value; they are simply worth what people are willing to pay for them in the market.
          </p>
        </div>
        <div
          className={`work-provided-services ${window.innerWidth <= 768 ? "d-none" : ""
            }`}
        >
          <h2>Services we provided</h2>
          <ul>
            <li>Analytic Driven Iterations</li>
            <li>Market Research</li>
            <li>Product Design</li>
            <li>UI/UX Design</li>
            <li>Web Design</li>
          </ul>
        </div>
      </div>

      {/* Work Section 1 */}
      <div className="work-section-1">
        <h1 className={`${window.innerWidth <= 768 ? "d-none" : ""}`}>Smart Contracts, And Regulatory Frameworks</h1>
        <img
          src="/assets/images/work-pages/crypto/crypto-2.webp"
          alt="Work Image"
        />

        <div
          className={`work-provided-services ${window.innerWidth > 768 ? "d-none" : ""
            }`}
        >
          <h2>Services we provided</h2>
          <ul>
            <li>Analytic Driven Iterations</li>
            <li>Market Research</li>
            <li>Product Design</li>
            <li>UI/UX Design</li>
            <li>Web Design</li>
          </ul>
        </div>

        <p className={`${window.innerWidth > 768 ? "d-none" : ""}`} >
          Cryptocurrencies are digital tokens. They are a type of digital currency that allows people to make payments directly to each other through an online system. Cryptocurrencies have no legislated or intrinsic value; they are simply worth what people are willing to pay for them in the market.
        </p>
      </div>

      {/* Work Section 2 */}
      <div className="work-section-2">
        <h1>Modernizing one of the biggest trading tools.</h1>
        <p className={`${window.innerWidth <= 768 ? "d-none" : ""}`}>
          Founded over 10 years, Stocklabs is one of the biggest trading tools to date, offering multiple services and comprising a multitude of valuable features for short-term traders and long-term investors alike. Stocklabs approached us with a request to update their design. We were tasked with the redesign of their entire website, UI/UX improvement, and optimization of their product.
        </p>
        <p className={`${window.innerWidth <= 768 ? "d-none" : ""}`}>
          During our discovery phase, we analyzed customer needs and discussed a fitting design approach for the new platform. We quickly decided on what would be the best solution: a minimalistic, clean design. Given that Stocklabs’ supplies its users with a range of information, news, and data on the stock market, it was crucial to display this intelligence in an efficient, easy-to-understand style.
        </p>
        <p className={`${window.innerWidth <= 768 ? "d-none" : ""}`}>
          Following this approach, we were able to keep the platform simple and professional, while still highlighting Stocklabs’ unique features. Important data immediately catches the user’s eye through the implementation of vibrant colors.
        </p>
        <img
          src="/assets/images/work-pages/crypto/crypto-3.webp"
          alt="Work Image"
        />
        <div className="d-flex justify-content-center">
          <img
            src="/assets/images/work-pages/crypto/crypto-4.webp"
            alt="Work Image"
          />
          <img
            src="/assets/images/work-pages/crypto/crypto-5.webp"
            alt="Work Image"
          />
        </div>

        <p className={`${window.innerWidth > 768 ? "d-none" : ""}`}>
          Founded over 10 years, Stocklabs is one of the biggest trading tools to date, offering multiple services and comprising a multitude of valuable features for short-term traders and long-term investors alike. Stocklabs approached us with a request to update their design. We were tasked with the redesign of their entire website, UI/UX improvement, and optimization of their product.
        </p>
        <p className={`${window.innerWidth > 768 ? "d-none" : ""}`}>
          During our discovery phase, we analyzed customer needs and discussed a fitting design approach for the new platform. We quickly decided on what would be the best solution: a minimalistic, clean design. Given that Stocklabs’ supplies its users with a range of information, news, and data on the stock market, it was crucial to display this intelligence in an efficient, easy-to-understand style.
        </p>
        <p className={`${window.innerWidth > 768 ? "d-none" : ""}`}>
          Following this approach, we were able to keep the platform simple and professional, while still highlighting Stocklabs’ unique features. Important data immediately catches the user’s eye through the implementation of vibrant colors.
        </p>
      </div>

      {/* Work Section 3 */}
      <div className="work-section-3">
        <h1>The Results</h1>
        <img
          className={`${window.innerWidth > 768 ? "d-none" : ""}`}
          src="/assets/images/work-pages/crypto/crypto-6.webp"
          alt="Work Image"
        />
        <p>
          Following 4 months of close collaboration with our client, we successfully launched the new and modernized platform. Leveraging knowledge we gained from numerous past fintech projects, we included sophisticated design approaches to bring Stocklabs’ platform to the next level. We placed the user at the centre of the project, and designed the website to be as intuitive and efficient as possible, ensuring a smooth user flow throughout every feature.
        </p>
        <h2>
          The outcome: a refreshing and professional website design that reflects the unmatched features and services provided by Stocklabs.
        </h2>
        <img
          className={`${window.innerWidth <= 768 ? "d-none" : ""}`}
          src="/assets/images/work-pages/crypto/crypto-6.webp"
          alt="Work Image"
        />
      </div>

      <OurWorksSection workPageId={id} />
    </div>
  );
}

export default WorkCrypto;
